export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const CHECK_LOGIN = 'CHECK_LOGIN';
export const GET_USER = 'GET_USER';
export const ADD_TWEET = 'ADD_TWEET';
export const REMOVE_TWEET = 'REMOVE_TWEET';
export const ADD_LIKED = 'ADD_LIKED';
export const REMOVE_LIKED = 'REMOVE_LIKED';
export const UPDATE_USER_IMAGE = 'UPDATE_USER_IMAGE';
export const FOLLOW_USER = 'FOLLOW_USER';
export const UNFOLLOW_USER = 'UNFOLLOW_USER';
